module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Kj-Lc.c7eed98b.png";